import { render, staticRenderFns } from "./KnowledgeBaseDetailed.vue?vue&type=template&id=4b8b2b01&scoped=true&"
import script from "./KnowledgeBaseDetailed.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseDetailed.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseDetailed.vue?vue&type=style&index=0&id=4b8b2b01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b2b01",
  null
  
)

export default component.exports